import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '装饰辅材行业联盟'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '联盟成员'
          }
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/chairman',
          name:'chairman',
          component: resolve => require(['@/view/chairman'], resolve),
          meta: {
            title: '联盟架构丨主席'
          }
        },
        {
          path: '/chairman2',
          name:'chairman2',
          component: resolve => require(['@/view/chairman2'], resolve),
          meta: {
            title: '联盟架构丨副主席'
          }
        },
        {
          path: '/secretariat',
          name:'secretariat',
          component: resolve => require(['@/view/secretariat'], resolve),
          meta: {
            title: '联盟架构丨秘书处'
          }
        },
        {
          path: '/member',
          name:'member',
          component: resolve => require(['@/view/member'], resolve),
          meta: {
            title: '联盟架构丨成员'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '加入联盟'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '联盟成员介绍'
          }
        },
        {
          path: '/newsdetail',
          name: 'newsdetail',
          component: resolve => require(['@/view/NewsDetail'],resolve),
          meta: {
            title: '新闻动态'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js